module.exports = __webpack_public_path__ + "img/check-mark-purple.8f570b39.svg";